module.exports = __webpack_public_path__ + "img/isimg.8d3ff73c.png";